import { Flex } from '@teamsparta/stack-flex';

import * as D from '../../data';
import type { PixelType } from '../../type';
import { ProgressBar } from '../ProgressBar/template';
import { TotalCurrentGrass } from '../TotalCurrentGrass/template';
import { TreePattern } from '../TreePattern/template';
import {
  calculateProgressPercent,
  getLayerFillCountTwoPhase,
  getPhaseCountMessage,
  getUserContribution,
} from './logic';
import * as S from './style';

export interface ChristmasTreeProps {
  pixels: PixelType[][];
  currentPhase: number;
  fillCount: number;
  userContribution?: {
    startPixel: number;
    pixelCount: number;
  };
  totalContributionData: number;
}

export function ChristmasTree({
  pixels,
  currentPhase,
  fillCount,
  userContribution,
  totalContributionData,
}: ChristmasTreeProps) {
  const progress = calculateProgressPercent(
    currentPhase,
    totalContributionData,
  );
  const phaseCountMessage = getPhaseCountMessage(currentPhase);

  return (
    <>
      <S.TreeWrapper>
        {D.TREE_LAYERS.map((layerConfig, index) => (
          <TreePattern
            key={`${layerConfig.id}-${index}`}
            pixels={pixels}
            layerConfig={layerConfig}
            layerIndex={index}
            fillCount={getLayerFillCountTwoPhase(
              index,
              currentPhase,
              fillCount,
            )}
            userContribution={getUserContribution(
              index,
              currentPhase,
              userContribution,
            )}
          />
        ))}
      </S.TreeWrapper>
      <Flex.Column align='start' gap='8px' style={{ width: '100%' }}>
        {phaseCountMessage && (
          <S.PhaseCountText>{phaseCountMessage}</S.PhaseCountText>
        )}
        <ProgressBar progress={progress} />
        <TotalCurrentGrass totalContributionData={totalContributionData} />
      </Flex.Column>
    </>
  );
}
